import * as React from 'react';

export default (
  <svg height="16" viewBox="0 0 16 16">
    <path
      d="m9.78667012 12.4444504h-6.23111654v-1.7777748h6.23111654zm2.66666518-3.55554966h-8.89778172v-1.77777481h8.89778172zm0-3.5555763h-8.89778172v-1.77777481h8.89778172zm1.7688879-5.33332444h-12.44444641c-.98222168 0-1.77777679.79643423-1.77777679 1.77777481v12.44445039c0 .9813317.79555511 1.7777748 1.77777679 1.7777748h12.44444641c.9813328 0 1.7777768-.7964431 1.7777768-1.7777748v-12.44445039c0-.98134058-.796444-1.77777481-1.7777768-1.77777481z"
      fill="#fff"
    />
  </svg>
);
